import React, { useEffect, useState } from "react";
import "./Home.css";

const Home = () => {
  const villageName = "सोनेगाव";

  const sarpanch = {
    name: "सौ. रुपाली हरीश पुनतकर",
    photo: "/images/sarpanch.jpeg",
  };

  const upsarpanch = {
    name: "सौ. गायत्री लालाजी आंबोले",
    photo: "/images/upsarpanch.jpeg",
  };

  const members = [
    { sr: 1, name: "सौ.माधुरी नंदगोपाल सोमकुवर", ward: "सदस्य", phone: "9579853120" },
    { sr: 2, name: "श्री. दिनेश हरिमोहन झोशी", ward: "सदस्य", phone: "9823159075" },
    { sr: 3, name: "श्री. शुद्धधन ज्ञानदेव पाटील", ward: "सदस्य", phone: "9284074946" },
    { sr: 4, name: "सौ. विनिता कडू राव", ward: "सदस्य", phone: "7666510161" },
    { sr: 5, name: "सौ. माधुरी अशोक गायकवाड", ward: "सदस्य", phone: "9637382467" },
    { sr: 6, name: "श्री. शरद मुरलीधर ठाकरे", ward: "सदस्य", phone: "9049166852" },
    { sr: 7, name: "श्री. ओमप्रकाश मुलचंद वरठे", ward: "सदस्य", phone: "8767468955" },
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback = "https://via.placeholder.com/300x300/D3D3D3/666666?text=फोटो+नाही";
    const [img, setImg] = useState(src);

    return (
      <img
        src={img}
        alt={alt}
        onError={() => setImg(fallback)}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  };

  return (
    <div className="home-container">
      <div className="marquee-wrapper">
        <div className="marquee">
          गट ग्रामपंचायत सोनेगाव | पंचायत समिती कळमेश्वर, जि. नागपूर | संपर्क:- 9881245686
        </div>
      </div>

            {/* नवीन Hero Section – Background Video with Sound Control */}
      <section className="hero-video-section">
        <video
          autoPlay
          loop
          playsInline
          className="background-video"
          id="villageVideo"  // ID जोडली
          muted                     // सुरुवातीला muted ठेवतो
        >
          <source src="/images/sonegaon.mp4" type="video/mp4" />
          तुमचा ब्राउजर video सपोर्ट करत नाही.
        </video>

        <div className="video-overlay">
          <h1 className="video-title">गट ग्रामपंचायत "{villageName}"</h1>
          
          {/* Sound On Button */}
          <button className="sound-btn" onClick={() => {
            const video = document.getElementById('villageVideo');
            video.muted = false;
            video.play(); // पुन्हा play करतो sound सह
            document.querySelector('.sound-btn').style.display = 'none'; // button लपवतो
          }}>
            🔊 आवाज चालू करा
          </button>
        </div>
      </section>

      <section className="section">
        <h2 className="title">गट ग्रामपंचायत प्रतिनिधी</h2>
        <div className="layout">
          <div className="leaders">
            <div className="leader-card sarpanch-card">
              <div className="leader-img">
                <SafeImage src={sarpanch.photo} alt="सरपंच" />
              </div>
              <h3>सरपंच</h3>
              <b>{sarpanch.name}</b>
              <br />
              <a href="/sarpanch" className="more-info-link">अधिक माहिती →</a>
            </div>

            <div className="leader-card upsarpanch-card">
              <div className="leader-img">
                <SafeImage src={upsarpanch.photo} alt="उपसरपंच" />
              </div>
              <h3>उपसरपंच</h3>
              <b>{upsarpanch.name}</b>
              <br />
              <a href="/upsarpanch" className="more-info-link">अधिक माहिती →</a>
            </div>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>सदस्याचे नाव</th>
                  <th>पद</th>
                  <th>फोन क्र.</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m.sr}>
                    <td>{m.sr}</td>
                    <td>{m.name}</td>
                    <td>{m.ward}</td>
                    <td>{m.phone || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="map-section">
        <h2 className="map-title">📍गट ग्रामपंचायत सोनेगाव – स्थान</h2>
        <p className="map-subtitle">
          गट ग्रामपंचायत सोनेगाव, तालुका कळमेश्वर, जिल्हा नागपूर
        </p>

        <div className="map-container">
          <iframe
            title="Sonegaon Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.646916762397!2d79.0465179!3d21.0962948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf959e5b78dd%3A0x5ac819036ab6ddde!2sSonegaon%2C%20Nagpur%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1700000000000"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Home;